import script from "./RefiProgramLoanOptions.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefiProgramLoanOptions.vue?vue&type=script&setup=true&lang=ts"

import "./RefiProgramLoanOptions.vue?vue&type=style&index=0&id=3188530c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3188530c"]])

export default __exports__